import React from 'react';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
export function SocialProofBar() {
  return <section className="border-y border-mp-lime/40 bg-[#080d11] py-6 md:py-7" data-id="element-247" data-mp="2erz7iikhhkw1">
      <Container className="flex flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4" data-id="element-248" data-mp="29vh3jkwz9qkr">
        <div className="flex items-center gap-2" data-id="element-249" data-mp="25u599235sh68">
          <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-250" data-mp="32j4o4zy90h7e">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-251" data-mp="2xl33ial6c9tt" data-mpi={i} />)}
          </div>
          <span className="font-heading text-sm uppercase tracking-wide text-mp-white md:text-base" data-id="element-252" data-mp="2th3ppzra3p45">
            4,9/5 · +200 monitores en España
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-mp-gray sm:text-sm" data-id="element-253" data-mp="1i3sy7icma4bf">
          <span data-id="element-254" data-mp="1d3542nt3d7cz">✓ El estándar profesional en pista</span>
          <span data-id="element-255" data-mp="18ob4wih04f1t">✓ Sistema probado en clubes reales</span>
        </div>
      </Container>
    </section>;
}